import { Mail, Store, Gift, Trophy, ScanSearch, Repeat, Package } from "lucide-react";

export const CONTACTS = [
  { email: "info@cardsource.eu", title: "Informazioni generali", text: "Domande sul negozio, disponibilità, eventi e tornei", color: "bg-amber-500" },
  { email: "help.order@cardsource.eu", title: "Assistenza ordini", text: "Stato spedizioni, resi, problemi con un ordine", color: "bg-cyan-500" },
  { email: "b2b@cardsource.eu", title: "Ingrosso B2B", text: "Rivendita all'ingrosso di prodotti sigillati per negozi", color: "bg-violet-500" },
];

export const SERVICES = [
  { icon: Package, title: "Ingrosso e dettaglio", text: "Rivendita all'ingrosso e al dettaglio di prodotti sigillati TCG", color: "text-amber-600" },
  { icon: Repeat, title: "Compravendita singole", text: "Compravendita di carte singole collezionabili", color: "text-rose-500" },
  { icon: ScanSearch, title: "Pre-grading", text: "Pre-grading delle tue carte singole collezionabili", color: "text-cyan-600" },
  { icon: Trophy, title: "Eventi e tornei", text: "Organizzazione di eventi locali e tornei ufficiali", color: "text-violet-500" },
  { icon: Store, title: "Spazio di ritrovo", text: "Ampio spazio di ritrovo climatizzato per giocare", color: "text-amber-600" },
  { icon: Gift, title: "Gadget e regali", text: "Gadget, idee regalo nerd e molto altro!", color: "text-rose-500" },
];

export const ContactCards = () => (
  <div className="grid gap-5 md:grid-cols-3" data-testid="contact-cards">
    {CONTACTS.map((c) => (
      <a key={c.email} href={`mailto:${c.email}`} data-testid={`contact-${c.email.split("@")[0].replace(".", "-")}`}
        className="sticker-btn group flex flex-col rounded-2xl bg-[#FFFFFF] p-6">
        <span className={`flex h-12 w-12 items-center justify-center rounded-xl border-2 border-black ${c.color}`}><Mail className="h-5 w-5 text-black" /></span>
        <p className="mt-5 font-display text-xl font-semibold">{c.title}</p>
        <p className="mt-1 text-sm text-stone-600">{c.text}</p>
        <p className="mt-5 break-all font-mono text-sm font-semibold text-amber-600 group-hover:underline">{c.email}</p>
      </a>
    ))}
  </div>
);

export const ServicesGrid = () => (
  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="services-grid">
    {SERVICES.map((s, i) => (
      <div key={s.title} className="fade-up flex gap-4 rounded-2xl border border-black/[0.08] bg-[#FFFFFF] p-6" style={{ animationDelay: `${i * 60}ms` }} data-testid={`service-${i}`}>
        <s.icon className={`h-7 w-7 shrink-0 ${s.color}`} />
        <div>
          <p className="font-display text-lg font-semibold">{s.title}</p>
          <p className="mt-1 text-sm text-stone-600">{s.text}</p>
        </div>
      </div>
    ))}
  </div>
);

export const GamesStrip = () => (
  <div className="rounded-3xl bg-black px-6 py-8" data-testid="games-strip">
    <p className="mb-4 text-center font-display text-sm uppercase tracking-[0.25em] text-stone-600">I giochi che trattiamo</p>
    <img src="/brand/games.png" alt="Magic, Pokémon, One Piece, Yu-Gi-Oh!, Riftbound, Lorcana, Dragon Ball Super" className="mx-auto w-full max-w-3xl" />
  </div>
);
